export const dateExpired = (timestamp, expireInMs) => {
  const time = new Date(timestamp).getTime();
  return Date.now() - time > expireInMs;
};
//# sourceMappingURL=dateExpired.js.map